import { useNavigate } from 'react-router-dom';
import { Package, AlertTriangle, Bell, X, ArrowRight } from 'lucide-react';

// Popup notification (first 2 reminders)
export const DispatchPopup = ({ count, onDismiss, onNavigate }) => (
  <div
    className="fixed top-4 left-4 right-4 z-[9999] animate-slideDown"
    data-testid="dispatch-popup-notification"
  >
    <div className="bg-gradient-to-r from-red-600 to-orange-600 rounded-xl p-4 shadow-2xl shadow-red-500/30 border border-red-400/30">
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center shrink-0 animate-pulse">
          <Bell size={24} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-bold text-lg">
            Nouvelle commande !
          </h3>
          <p className="text-red-100 text-sm mt-0.5">
            {count === 1
              ? "Vous avez 1 nouvel arret assigne"
              : `Vous avez ${count} nouveaux arrets assignes`
            }
          </p>
          <button
            onClick={onNavigate}
            className="mt-3 bg-white text-red-600 font-bold text-sm px-5 py-2 rounded-lg flex items-center gap-2 hover:bg-red-50 transition-colors"
            data-testid="dispatch-popup-go-btn"
          >
            <Package size={16} />
            Voir mes commandes
            <ArrowRight size={16} />
          </button>
        </div>
        <button
          onClick={onDismiss}
          className="p-1 hover:bg-white/20 rounded-lg text-white/80 shrink-0"
          data-testid="dispatch-popup-dismiss"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  </div>
);

// Full-screen blocking banner (3rd+ reminders)
export const DispatchFullscreen = ({ count, onNavigate }) => (
  <div
    className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-6"
    data-testid="dispatch-fullscreen-notification"
  >
    <div className="max-w-md w-full text-center">
      {/* Pulsing alarm icon */}
      <div className="relative mx-auto w-28 h-28 mb-6">
        <div className="absolute inset-0 bg-red-500/30 rounded-full animate-ping" />
        <div className="absolute inset-2 bg-red-500/50 rounded-full animate-pulse" />
        <div className="relative w-28 h-28 bg-red-600 rounded-full flex items-center justify-center">
          <AlertTriangle size={48} className="text-white" />
        </div>
      </div>

      <h1 className="text-3xl font-black text-white mb-2">
        COMMANDE EN ATTENTE
      </h1>
      <p className="text-red-400 text-xl font-semibold mb-2">
        {count === 1
          ? "1 arret non consulte"
          : `${count} arrets non consultes`
        }
      </p>
      <p className="text-slate-400 text-sm mb-8">
        Veuillez consulter vos commandes immediatement
      </p>

      <button
        onClick={onNavigate}
        className="w-full bg-red-600 hover:bg-red-500 text-white font-bold text-lg py-4 px-8 rounded-xl flex items-center justify-center gap-3 transition-colors animate-pulse"
        data-testid="dispatch-fullscreen-go-btn"
      >
        <Package size={24} />
        Ouvrir mes commandes
        <ArrowRight size={24} />
      </button>
    </div>
  </div>
);

// Main notification wrapper
export const DispatchNotification = ({ newStopsCount, notificationType, showNotification, dismissPopup }) => {
  const navigate = useNavigate();

  if (!showNotification || newStopsCount === 0) return null;

  const handleNavigate = () => {
    dismissPopup();
    navigate('/orders');
  };

  if (notificationType === 'fullscreen') {
    return <DispatchFullscreen count={newStopsCount} onNavigate={handleNavigate} />;
  }

  return <DispatchPopup count={newStopsCount} onDismiss={dismissPopup} onNavigate={handleNavigate} />;
};
